<template>
  <div>
    <div style="display: flex; justify-content: space-between; width: 100%">
      <div><img src="../../../static/img/index/announcement.png" alt="" /></div>
      <a-carousel
        :dot-position="dotPosition"
        class="title_loop"
        :autoplay="autoplay"
        dots = 'false'
      >
        <div
          class="title_loop_content"
          v-for="(item, index) in list"
          :key="index"
        >
          <div>
            <router-link
              tag="span"
              :to="{
                path: '/scNewsDetail',
                query: {
                  newsId: item.newsId,
                  navText: item.newsTitle,
                  title: item.newsTitle,
                  source: item.source,
                  createBy: item.createBy,
                  newsTitle: item.newsTitle,
                  urlAddress: item.urlAddress,
                },
              }"
            >
              {{ item.newsTitle }}</router-link>
          </div>
          <div>
            <router-link
              tag="span"
              :to="{
                path: '/scNewsDetail',
                query: {
                  newsId: item.newsId,
                  navText: item.newsTitle,
                  title: item.newsTitle,
                  source: item.source,
                  createBy: item.createBy,
                  newsTitle: item.newsTitle,
                  urlAddress: item.urlAddress,
                },
              }"
            >
              {{ item.sNewsTitle }}</router-link>
          </div>
        </div>
      </a-carousel>
    </div>
  </div>
</template>
<script>
import { postNewsByPage } from "../../api/api";
export default {
  data() {
    return {
      dotPosition: "right",
      list: [1,2,3,4,5,6,7,8,9,9],
      autoplay: false,
    };
  },
  created() {
    postNewsByPage(26467290138211, 1, 5).then((res) => {
      console.log(res.list,'aaaaaaaaaaaa');
      this.list = res.list;
    });
  },
  mounted() {
    this.autoplay = true;
  },
};
</script>
<style scoped>
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 82px;
  line-height: 82px;
  overflow: hidden;
}
div /deep/ .title_loop div div {
  height: 82px !important;
  line-height: 82px !important;
}
.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}

.title_loop {
  width: 88%;
  height: 82px;
}
.title_loop_content {
  padding: 0 20px;
}
.title_loop_content > div {
  float: left;
  width: 50%;
}
.title_loop_content > div > span:nth-of-type(1) {
  color: #333;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.title_loop_content > div > span:nth-of-type(2) {
  color: #9e9d9d;
}
div /deep/ .ant-carousel-vertical .slick-dots li.slick-active button,
div /deep/ .ant-carousel .slick-dots li button {
  width: 10px !important;
  height: 10px !important;
}
div /deep/ .ant-carousel .slick-dots li.slick-active button {
  background: #016ba9 !important;
  opacity: 1;
  border-radius: 50% !important;
}
div /deep/ .ant-carousel .slick-dots li button {
  border-radius: 50% !important;
  background: #9e9d9d !important;
}
.title_loop_content > div {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/indexComp/indexContentTop.vue